<button
  mat-button
  type="button"
  class="qaroni-close-icon"
  [mat-dialog-close]="false"
  tabindex="-1">
  <mat-icon>close</mat-icon>
</button>

<div mat-dialog-title class="mat-mdc-dialog-title">{{ title }}</div>

@if (message) {
  <mat-dialog-content class="mat-dialog-message">
    <p class="mb-0">{{ message }}</p>
  </mat-dialog-content>
}

<mat-dialog-actions align="center">
  <div class="flex w-full items-center justify-center gap-5">
    <button
      mat-flat-button
      type="button"
      class="qaroni-rounded-button m-1"
      [color]="cancelColorButton"
      [mat-dialog-close]="false">
      @if (cancelMatIcon) {
        <mat-icon class="me-1">
          {{ cancelMatIcon }}
        </mat-icon>
      }
      {{ cancelText }}
    </button>

    <button
      mat-flat-button
      type="button"
      class="qaroni-rounded-button m-1"
      [color]="confirmColorButton"
      [mat-dialog-close]="true">
      @if (confirmMatIcon) {
        <mat-icon class="me-1">
          {{ confirmMatIcon }}
        </mat-icon>
      }
      {{ confirmText }}
    </button>
  </div>
</mat-dialog-actions>
